import React from "react";
import { NavContainer, Item, SLink } from "./styled";
import items from "./items";
import handleLogout from "./navUtils/logout";
import { MAINVIEW_PATH } from "../../../constValues";
import { useLocation, useNavigate } from "react-router-dom";
import { SignInReducer } from "../../../../types/reducers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SHOW = 1;

interface IProps {
  cleanReducers: () => void;
  signInReducer: SignInReducer;
}

const Navbar = <P extends IProps>(props: P) => {
  const {
    cleanReducers,
    signInReducer: { menuList }
  } = props;
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <React.Fragment>
      {localStorage.token && (
        <NavContainer>
          <Item isPath={pathname === items.home.path}>
            <SLink to={items.home.path}>
              <FontAwesomeIcon icon={items.home.icon} size="2x" />
            </SLink>
          </Item>
          {menuList[0]?.web_approval_flag === SHOW && (
            <React.Fragment>
              <Item isPath={pathname === items.approval.path}>
                <SLink to={items.approval.path}>
                  <FontAwesomeIcon icon={items.approval.icon} size="2x" />
                </SLink>
              </Item>
              <Item isPath={pathname === items.request.path}>
                <SLink to={items.request.path}>
                  <FontAwesomeIcon icon={items.request.icon} size="2x" />
                </SLink>
              </Item>
            </React.Fragment>
          )}
          <Item
            isPath={pathname === items.des.path}
            onClick={() => navigate(`${MAINVIEW_PATH}home`)}
          >
            <SLink to={pathname}>
              <FontAwesomeIcon icon={items.des.icon} size="2x" />
            </SLink>
          </Item>
          <Item isPath={pathname === items.settings.path}>
            <SLink to={items.settings.path}>
              <FontAwesomeIcon icon={items.settings.icon} size="2x" />
            </SLink>
          </Item>
          <Item
            isPath={pathname === items.logOut.path}
            onClick={() => {
              handleLogout(cleanReducers);
            }}
          >
            <SLink to={items.logOut.redirect}>
              <FontAwesomeIcon icon={items.logOut.icon} size="2x" />
            </SLink>
          </Item>
        </NavContainer>
      )}
    </React.Fragment>
  );
};

export default Navbar;
